import React, { useState } from "react";
import { Box, Button, Container, TextField, Typography } from "@mui/material";

const fieldSx = {
  backgroundColor: "transparent !important",
  background: "transparent !important",
  "& .MuiInputBase-root, & .MuiInputBase-root input": { backgroundClip: "padding-box" },
  "& .MuiOutlinedInput-root": {
    color: "#fff",
    backgroundColor: "#15151a",
    borderRadius: "12px",
    "& fieldset": { borderColor: "rgba(255,255,255,.18)" },
    "&:hover fieldset": { borderColor: "#d4163c" },
    "&.Mui-focused fieldset": { borderColor: "#d4163c" },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,.6)" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#d4163c" },
};

const Contact: React.FC = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [trap, setTrap] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "ok" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (trap) return;
    setStatus("sending");
    try {
      const res = await fetch("https://api.besteurogirls.com/api/v1/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message, website: trap }),
      });
      if (!res.ok) throw new Error("bad status");
      setStatus("ok");
      setName("");
      setEmail("");
      setMessage("");
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4, color: "#e8e8ec" }}>
      <Typography variant="h3" sx={{ color: "#fff", fontWeight: 700, mb: 3 }}>
        Contact
      </Typography>
      <Typography sx={{ mb: 2, lineHeight: 1.7 }}>
        Dear visitors, we are an escort directory (an advertising platform), not
        an escort agency. If you want to book the girl is necessary to contact
        her directly in her Advert on our website. We don´t arrange meetings
        between the girls and clients! We are an escort directory website.
      </Typography>
      <Box component="ul" sx={{ pl: 3, mb: 4, lineHeight: 1.8 }}>
        <li>
          Please consult our FAQ before sending a message, as most common
          questions are answered there.
        </li>
        <li>
          If you have any questions please contact our manager. We reply in few
          hours and always within 48 hours.
        </li>
        <li>
          Contact us via email at info@besteurogirls.com or via the contact form
          below.
        </li>
        <li>
          Your suggestions and reminders regarding the functionality of our
          website are also welcome!
        </li>
      </Box>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <TextField label="Name" required value={name} sx={fieldSx}
          inputProps={{ maxLength: 80 }} onChange={(e) => setName(e.target.value)} />
        <TextField label="Email" type="email" required value={email} sx={fieldSx}
          inputProps={{ maxLength: 120 }} onChange={(e) => setEmail(e.target.value)} />
        <TextField label="Message" required multiline minRows={6} value={message}
          sx={fieldSx} inputProps={{ maxLength: 2000 }}
          onChange={(e) => setMessage(e.target.value)} />
        <input type="text" name="website" value={trap} tabIndex={-1}
          autoComplete="off" onChange={(e) => setTrap(e.target.value)}
          style={{ position: "absolute", left: "-9999px" }} aria-hidden="true" />
        <Button type="submit" variant="contained" size="large"
          sx={{ alignSelf: "flex-start", px: 5, borderRadius: "12px", backgroundColor: "#d4163c",
            "&:hover": { backgroundColor: "#a8102f" } }}>
          {status === "sending" ? "Sending..." : "Send"}
        </Button>
        {status === "ok" && (
          <Typography sx={{ color: "#4caf50" }}>
            Thank you! Your message has been sent.
          </Typography>
        )}
        {status === "error" && (
          <Typography sx={{ color: "#ff6b6b" }}>
            Sorry, the message could not be sent. Please try again later or email info@besteurogirls.com.
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export { Contact };
